export default class I18n {

    public static has(key:string):boolean{
        let w = (window as unknown as I18nWindow);
        return w.i18n && (w.i18n as any).hasOwnProperty(key);
    }

    public static get(key:string):any{
        let w = (window as unknown as I18nWindow);
        return (w.i18n as any)[key];
    }

    public static getOrElse(key:string, orElse: any):any{
        if(I18n.has(key)){
            return I18n.get(key);
        }
        return orElse;
    }
}

interface I18nWindow extends Window {
    i18n: any | undefined;
}